import tw, { styled } from 'twin.macro'
import React from 'react'
import { navigate } from 'gatsby'

import { useAnswerState } from 'context/AnswerContext'
import { useQuestionStep } from 'context/QuestionStepContext'
import getResultType from './getResultType'
import { TOTAL_QUESTION_COUNT } from 'constants/index'
import ProgressBar from 'components/ProgressBar'
import Button from 'components/Button'

interface Answer {
  message: string
}

interface QuestionProps {
  question: string
  answers: Answer[]
}

const Root = styled.div`
  ${tw`w-full h-full xs:p-40 sm:p-2xl`}
`

const Title = styled.div`
  ${tw`text-3xl sm:text-4xl md:text-5xl font-extralight mb-xl`}
`

const ButtonGroupWrapper = styled.div`
  ${tw`mt-2xl`}
`

const Question: React.FC<QuestionProps> = ({ question, answers }) => {
  const { setAnswer, answers: currentAnswers } = useAnswerState()
  const { currentStep, goToNextStep } = useQuestionStep()

  const handleGetResult = (lastAnswer: number) => {
    const totalAnswers = [...currentAnswers, lastAnswer]
    const resultType = getResultType(totalAnswers)
    navigate(`/result/${resultType}/`)
  }

  const handleAnswer = (answer: number) => {
    setAnswer(currentStep, answer)
    currentStep < TOTAL_QUESTION_COUNT
      ? goToNextStep()
      : handleGetResult(answer)
  }

  return (
    <Root>
      <ProgressBar step={currentStep} />
      <div tw="pt-xl">
        <Title>
          Q.{currentStep} {question}
        </Title>
        <ButtonGroupWrapper>
          {answers.map((answer, index) => (
            <div key={answer.message} tw="mb-18">
              <Button
                full
                onClick={() => handleAnswer(index)}
                variant="outlined"
                message={answer.message}
              />
            </div>
          ))}
        </ButtonGroupWrapper>
      </div>
    </Root>
  )
}

export default Question
